import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtitle-2 mt-3" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_base_table_header = _resolveComponent("base-table-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_create_or_update_permission_modal = _resolveComponent("create-or-update-permission-modal")!
  const _component_base_confirmation_modal = _resolveComponent("base-confirmation-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_page_header, {
              "main-title": _ctx.$t('permissions')
            }, {
              subheader: _withCtx(() => [
                _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t(
                $setup.permissionMutationIsEnabled
                  ? 'permissionsDesc'
                  : 'permissionsDescReadOnly'
              )), 1)
              ]),
              _: 1
            }, 8, ["main-title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_base_table_header, {
      "row-count": $setup.allPermissionsCount,
      "quantity-message": _ctx.$t('permissions'),
      "no-filter": "",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        ($setup.permissionMutationIsEnabled)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: $setup.openCreatePermissionModal
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, "+ " + _toDisplayString(_ctx.$t('newPermission')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["row-count", "quantity-message"]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_base_table, {
              "show-loading-table": $setup.loadingPermissions,
              "show-no-content-table": !$setup.pagePermissions.length,
              "error-message": _ctx.$t('noPermissions')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, { data: $setup.pagePermissions }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('name'),
                      prop: "name"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('category'),
                      prop: "category",
                      width: "250"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('description'),
                      prop: "description",
                      width: "350"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, { width: "80" }, {
                      default: _withCtx((props) => [
                        ($setup.permissionMutationIsEnabled)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              placement: "top",
                              content: _ctx.$t('editPermission')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: require(`@/assets/images/icons/new/edit.svg`),
                                  height: "14",
                                  width: "14",
                                  class: "action-icon",
                                  onClick: ($event: any) => ($setup.openUpdatePermissionModal(props.row))
                                }, null, 8, _hoisted_2)
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          : _createCommentVNode("", true),
                        ($setup.permissionMutationIsEnabled)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              placement: "top",
                              class: "ml-1",
                              content: _ctx.$t('deletePermission')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: require(`@/assets/images/icons/new/delete.svg`),
                                  height: "14",
                                  width: "14",
                                  class: "action-icon",
                                  onClick: ($event: any) => ($setup.openRemovePermissionModal(props.row))
                                }, null, 8, _hoisted_3)
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }, 8, ["show-loading-table", "show-no-content-table", "error-message"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_pagination, {
      count: $setup.allPermissionsCount,
      page: $setup.pageNumber,
      "page-size": $setup.pageSize,
      onChangePage: $setup.changePage
    }, null, 8, ["count", "page", "page-size", "onChangePage"]),
    _createVNode(_component_create_or_update_permission_modal, {
      modelValue: $setup.showCreateOrUpdatePermissionModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showCreateOrUpdatePermissionModal) = $event)),
      permission: $setup.permissionToCreateOrUpdate,
      onConfirm: $setup.createOrUpdatePermission,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCreateOrUpdatePermissionModal = false))
    }, null, 8, ["modelValue", "permission", "onConfirm"]),
    _createVNode(_component_base_confirmation_modal, {
      modelValue: $setup.showRemovePermissionConfirmationModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showRemovePermissionConfirmationModal) = $event)),
      content: _ctx.$t('confirmRemovePermission'),
      width: "600px",
      "feedback-text": _ctx.$t('permissionRemoved'),
      onConfirm: $setup.removePermission,
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showRemovePermissionConfirmationModal = false))
    }, null, 8, ["modelValue", "content", "feedback-text", "onConfirm"])
  ], 64))
}